export const validateEmail = (email: string) =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        .test(email);

export const validateShopifyHostname = (hostname: string) =>
    /[a-zA-Z0-9][a-zA-Z0-9\-]*\.myshopify\.com/.test(hostname) && !hostname.match(/\//ig);
